





































































import _ from "lodash";
import moment from "moment";
import Modal from "../core/Modals/Modal.vue";
import DateInput from "../core/Forms/DateInput.vue";
import { MaterielApi } from "../api/MaterielApi";
import { EntretienMateriel, ENTRETIEN_TYPES } from "../models/Materiel";

export default {
    name: "EntretienEditModal",
    components: { Modal, DateInput },
    props: {
        showModal: Boolean,
        equipement: Object,
        entretien: Object,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
            form: new EntretienMateriel(),
            saving: false,
            types: ENTRETIEN_TYPES,
        };
    },
    methods: {
        reset: function () {
            this.form = new EntretienMateriel(
                this.entretien ? this.entretien : undefined
            );

            if (!this.form.id) {
                this.form.date = moment().format("YYYY-MM-DD");
                this.form.type = ENTRETIEN_TYPES[0];
            }
            if (this.equipement) {
                this.form.equipement_id = this.equipement.id;
            }
        },
        setDate: function (value) {
            let date = moment(value, "DD/MM/YYYY", true);
            if (date.isValid()) {
                this.form.date = date.format("YYYY-MM-DD");
            } else if (!value) {
                this.form.date = null;
            }
        },
        save: function () {
            let self = this;

            if (!self.form.date) {
                self.$emit("toast", { message: "Date requise", kind: "error" });
                return;
            }
            if (!self.form.type) {
                self.$emit("toast", { message: "Type requis", kind: "error" });
                return;
            }

            self.saving = true;
            self.MaterielApi.saveEntretien(self.form)
                .then(function (saved) {
                    self.saving = false;
                    self.$emit("toast", {
                        message: "Intervention enregistrée",
                        kind: "success",
                    });
                    self.$emit("saved", saved);
                })
                .catch(function (error) {
                    self.saving = false;
                    self.$emit("toast", {
                        message: _.get(
                            error,
                            "response.data.message",
                            "Une erreur est survenue"
                        ),
                        kind: "error",
                    });
                });
        },
        close: function () {
            this.$emit("close-modal");
        },
    },
    watch: {
        showModal: {
            immediate: true,
            handler: function (value) {
                if (value) {
                    this.reset();
                }
            },
        },
        entretien: function () {
            if (this.showModal) {
                this.reset();
            }
        },
    },
};
